import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 py-20 text-center">
      <Heart className="text-brand-primary mb-5" size={36} strokeWidth={1.4} />
      <h1 className="font-serif-display text-6xl text-brand-text">404</h1>
      <p className="font-serif-display text-2xl mt-3">Page lost in kindness.</p>
      <p className="text-brand-muted mt-2 max-w-md">The page you're looking for doesn't exist — but plenty of stories do.</p>
      <Link to="/campaigns" className="btn-gold mt-7">Browse campaigns</Link>
    </div>
  );
}
